import React from 'react'
import './SuccessModal.css'
import { CustomButton } from '../../../common/ReusableComponent/CustomButton'
import { FaCheckCircle } from 'react-icons/fa'

const SuccessModal = ({ show, message, onClose }) => {
    if (!show) return null

    return (
        <div className="success-modal-overlay">
            <div className="success-modal">
                <FaCheckCircle className="success-icon" />
                <h3>Success!</h3>
                <p>{message}</p>
                <div className="success-modal-footer">
                    <CustomButton
                        text="OK"
                        backgroundColor="rgb(74, 85, 70)"
                        color="#fff"
                        width="100px"
                        height="40px"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    )
}

export default SuccessModal
